import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const items = [
  {
    q: "What is invoice financing?",
    a: "Invoice financing lets a business unlock the money tied up in unpaid customer invoices. Instead of waiting 30–90 days for payment, you receive working capital upfront against those receivables.",
  },
  {
    q: "Who can apply?",
    a: "MSMEs, manufacturers, wholesalers, exporters, distributors, service companies and agencies with recurring, verifiable B2B invoices are ideal fits for the Invoquity early access program.",
  },
  {
    q: "How long does it take?",
    a: "During early access, our target processing time for verified invoices is 24–48 hours after documentation is complete.",
  },
  {
    q: "Is collateral required?",
    a: "No. Invoquity's model is based on your invoices and buyer relationships — not on hard collateral or personal guarantees.",
  },
  {
    q: "Which industries are supported?",
    a: "Manufacturing, exports, wholesale, retail, IT services, marketing agencies, logistics, healthcare and construction, among others.",
  },
  {
    q: "Is Invoquity live?",
    a: "We are currently onboarding businesses for Early Access. Join the waitlist and our team will reach out to walk you through the process.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="py-24 md:py-32 bg-slate-50">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="text-center">
          <p className="text-xs font-bold uppercase tracking-[0.28em] text-emerald-700 mb-3">FAQ</p>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight text-slate-900">
            Answers, before you ask.
          </h2>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.5 }}
          className="mt-12"
        >
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {items.map((it, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-slate-200" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="text-left font-display text-base md:text-lg font-medium text-slate-900 py-5 hover:no-underline">
                  {it.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 leading-relaxed pb-5">
                  {it.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
